const isCancelled = Symbol("EventCanceller.isCancelled");

export class SelectionCanceller {
    private [isCancelled]: boolean = false;

    get isCancelled() {
        return this[isCancelled];
    }

    cancel() {
        this[isCancelled] = true;
    }
}
